// src/layouts/PageLayout.jsx
import { Helmet } from "react-helmet-async";

const PageLayout = ({ title, description, url, image, children }) => {
  const meta = {
    title: title || "Cell Station – Expert Cellphone Repair",
    description:
      description ||
      "Fast, reliable cellphone repair in Willow Grove, PA. iPhone, Samsung, iPad & more.",
    url: url || "https://www.icellstation.com/",
    image: image || "https://www.icellstation.com/assets/images/og-image.jpg",
  };

  return (
    <>
      <Helmet>
        <title>{meta.title}</title>
        <link rel="canonical" href={meta.url} />
        <meta name="description" content={meta.description} />
        <meta property="og:title" content={meta.title} />
        <meta property="og:description" content={meta.description} />
        <meta property="og:url" content={meta.url} />
        <meta property="og:image" content={meta.image} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={meta.title} />
        <meta name="twitter:description" content={meta.description} />
        <meta name="twitter:image" content={meta.image} />
      </Helmet>
      {children}
    </>
  );
};

export default PageLayout;

// src/components/layouts/PageLayout.js
// import React, { useEffect } from "react";

// const PageLayout = ({ title, children }) => {
//   useEffect(() => {
//     if (title) {
//       document.title = title;
//     }
//   }, [title]);

//   return <>{children}</>;
// };

// export default PageLayout;
